// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { BuildRequest, BuildRequestT, verifyBuildRequest } from "./build-request";
import { CheckRequest, CheckRequestT, verifyCheckRequest } from "./check-request";
import {
  EventsCheckRequest,
  EventsCheckRequestT,
  verifyEventsCheckRequest,
} from "./events-check-request";
import { IdlBody, unionToIdlBody, unionListToIdlBody } from "./idl-body";
import { IdlResult, IdlResultT, verifyIdlResult } from "./idl-result";
import { InflateRequest, InflateRequestT, verifyInflateRequest } from "./inflate-request";
import { ValidateRequest, ValidateRequestT, verifyValidateRequest } from "./validate-request";

export class IdlMessage implements flatbuffers.IUnpackableObject<IdlMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): IdlMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsIdlMessage(bb: flatbuffers.ByteBuffer, obj?: IdlMessage): IdlMessage {
    return (obj || new IdlMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsIdlMessage(bb: flatbuffers.ByteBuffer, obj?: IdlMessage): IdlMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new IdlMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static bufferHasIdentifier(bb: flatbuffers.ByteBuffer): boolean {
    return bb.__has_identifier("MCEI");
  }

  abiVersion(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  bodyType(): IdlBody {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : IdlBody.NONE;
  }

  body<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  static startIdlMessage(builder: flatbuffers.Builder) {
    builder.startObject(3);
  }

  static addAbiVersion(builder: flatbuffers.Builder, abiVersion: number) {
    builder.addFieldInt16(0, abiVersion, 0);
  }

  static addBodyType(builder: flatbuffers.Builder, bodyType: IdlBody) {
    builder.addFieldInt8(1, bodyType, IdlBody.NONE);
  }

  static addBody(builder: flatbuffers.Builder, bodyOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, bodyOffset, 0);
  }

  static endIdlMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 8); // body
    return offset;
  }

  static finishIdlMessageBuffer(builder: flatbuffers.Builder, offset: flatbuffers.Offset) {
    builder.finish(offset, "MCEI");
  }

  static finishSizePrefixedIdlMessageBuffer(
    builder: flatbuffers.Builder,
    offset: flatbuffers.Offset,
  ) {
    builder.finish(offset, "MCEI", true);
  }

  static createIdlMessage(
    builder: flatbuffers.Builder,
    abiVersion: number,
    bodyType: IdlBody,
    bodyOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    IdlMessage.startIdlMessage(builder);
    IdlMessage.addAbiVersion(builder, abiVersion);
    IdlMessage.addBodyType(builder, bodyType);
    IdlMessage.addBody(builder, bodyOffset);
    return IdlMessage.endIdlMessage(builder);
  }

  unpack(): IdlMessageT {
    return new IdlMessageT(
      this.abiVersion(),
      this.bodyType(),
      (() => {
        const temp = unionToIdlBody(this.bodyType(), this.body.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
    );
  }

  unpackTo(_o: IdlMessageT): void {
    _o.abiVersion = this.abiVersion();
    _o.bodyType = this.bodyType();
    _o.body = (() => {
      const temp = unionToIdlBody(this.bodyType(), this.body.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
  }

  unpackFields(...fields: string[]): IdlMessageT {
    const t = new IdlMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("abi_version")) {
      t.abiVersion = this.abiVersion();
    }
    if (fieldSet.has("body_type")) {
      t.bodyType = this.bodyType();
    }
    if (fieldSet.has("body")) {
      t.body = (() => {
        const temp = unionToIdlBody(this.bodyType(), this.body.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    return t;
  }
}

export class IdlMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public abiVersion: number = 0,
    public bodyType: IdlBody = IdlBody.NONE,
    public body:
      | BuildRequestT
      | CheckRequestT
      | EventsCheckRequestT
      | IdlResultT
      | InflateRequestT
      | ValidateRequestT
      | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.body === null || this.body === undefined) {
      throw new Error('Required field "body" is not set');
    }
    const body = builder.createObjectOffset(this.body);

    return IdlMessage.createIdlMessage(builder, this.abiVersion, this.bodyType, body);
  }

  clone(): IdlMessageT {
    const obj = new IdlMessageT();
    obj.abiVersion = this.abiVersion;
    obj.bodyType = this.bodyType;
    obj.body =
      this.body !== null && typeof (this.body as any).clone === "function"
        ? (this.body as any).clone()
        : this.body;
    return obj;
  }

  equals(other: IdlMessageT): boolean {
    if (this.abiVersion !== other.abiVersion) return false;
    if (this.bodyType !== other.bodyType) return false;
    if (this.body !== null && other.body !== null) {
      if (typeof (this.body as any).equals === "function") {
        if (!(this.body as any).equals(other.body)) return false;
      } else if (this.body !== other.body) return false;
    } else if (this.body !== other.body) return false;
    return true;
  }
}

export function verifyIdlMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
    verifier.checkScalarField(tablePos, 6, 1);
    verifier.checkUnionConsistency(tablePos, 6, 8, "body");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 6);
        switch (uType) {
          case 1: // ValidateRequest
            {
              const o = verifier.readInt32(pos);
              verifyValidateRequest(verifier, pos + o);
            }
            break;
          case 2: // BuildRequest
            {
              const o = verifier.readInt32(pos);
              verifyBuildRequest(verifier, pos + o);
            }
            break;
          case 3: // CheckRequest
            {
              const o = verifier.readInt32(pos);
              verifyCheckRequest(verifier, pos + o);
            }
            break;
          case 4: // InflateRequest
            {
              const o = verifier.readInt32(pos);
              verifyInflateRequest(verifier, pos + o);
            }
            break;
          case 5: // IdlResult
            {
              const o = verifier.readInt32(pos);
              verifyIdlResult(verifier, pos + o);
            }
            break;
          case 6: // EventsCheckRequest
            {
              const o = verifier.readInt32(pos);
              verifyEventsCheckRequest(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 8, "body");
  } finally {
    verifier.popDepth();
  }
}

export function verifyRootAsIdlMessage(buf: DataView, opts?: flatbuffers.VerifierOptions): void {
  const verifier = new flatbuffers.Verifier(buf, opts);
  const tablePos = verifier.readUint32(0);
  verifyIdlMessage(verifier, tablePos);
}
